"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cryptoWorker = require("@nettoken/crypto-worker");
var _helpers = require("@nettoken/helpers");
var _socket = require("@nettoken/socket");
var _events = require("../../actions/events");
var _const = require("../../actions/const");
var _qr = require("../../actions/qr");
var _QR = _interopRequireDefault(require("../QR"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var CROSS_ORIGIN = 'cross-origin';
var SAME_ORIGIN = 'same-origin';
var canRefreshCode = function canRefreshCode(count) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _const.QR_AUTH_REFRESH_LIMIT;
  return count < limit;
};
var isCrossOrigin = function isCrossOrigin(target) {
  return target === CROSS_ORIGIN;
};
var isSameOrigin = function isSameOrigin(target) {
  return target === SAME_ORIGIN;
};
var toValue = function toValue(publicKey, socketId) {
  var payload = {
    publicKey: publicKey,
    socketId: socketId
  };
  var value = publicKey && socketId ? (0, _qr.encodeQR)(_events.QR_EVENT_LOGIN, payload) : '';
  return value;
};
var QRAuth = /*#__PURE__*/function (_React$Component) {
  function QRAuth(props) {
    var _this;
    _classCallCheck(this, QRAuth);
    _this = _callSuper(this, QRAuth, [props]);
    _this.state = {
      blurred: false,
      counter: 0,
      loading: false,
      publicKey: '',
      refreshable: false,
      socketId: ''
    };
    _this.mounted = false;
    _this.target = props.target;
    _this.timer = null;
    _this.onRefresh = _this.onRefresh.bind(_this);
    if (props.getState) props.getState(_this.getState.bind(_this));
    if (props.passSocketMessage) props.passSocketMessage(_this.onSocketMessage.bind(_this));
    if (props.passState) props.passState(_this.passState.bind(_this));
    return _this;
  }
  _inherits(QRAuth, _React$Component);
  return _createClass(QRAuth, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.generateCode();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.target !== this.props.target) this.generateCode();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelTimer();
      if (this.props.onUnmount) {
        var shouldDisconnect = this.props.onUnmount();
        if (shouldDisconnect) this.socketDisconnect(null, true);
        // Caller might want to keep the socket connected.
        // This is the case for example when user signs in.
      } else if (isSameOrigin(this.target)) {
        this.socketDisconnect(null, true);
      }
      this.mounted = false;
    }
  }, {
    key: "addSocketHooks",
    value: function () {
      var _addSocketHooks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var processSocketEvent, connected;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              processSocketEvent = this.props.processSocketEvent;
              _context.next = 4;
              return processSocketEvent({
                event: _socket.SM_REQUIRE_SOCKET
              });
            case 4:
              _context.next = 6;
              return processSocketEvent({
                event: _socket.SM_IS_CONNECTED
              });
            case 6:
              connected = _context.sent;
              // Socket might be already connected. This would happen if we rendered
              // this component and then tried to render another instance without
              // disconnecting the socket when we unmounted the previous instance.
              // See `componentWillUnmount()` for explanation why this might happen.
              if (connected) this.onConnect();
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              this.onError(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function addSocketHooks() {
        return _addSocketHooks.apply(this, arguments);
      }
      return addSocketHooks;
    }()
  }, {
    key: "cancelTimer",
    value: function cancelTimer() {
      clearTimeout(this.timer);
    }
  }, {
    key: "generateCode",
    value: function () {
      var _generateCode = _asyncToGenerator(function () {
        var _this2 = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.target;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var targetChanged;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                targetChanged = _this2.target !== target;
                if (targetChanged) _this2.target = target;
                _this2.cancelTimer();
                if (isSameOrigin(_this2.target) && !targetChanged) {
                  _this2.addSocketHooks();
                } else if (isCrossOrigin(_this2.target) && !targetChanged) {
                  if (_this2.props.onConnect) _this2.props.onConnect();
                } else {
                  _this2.socketDisconnect(function () {
                    if (_this2.props.onConnect) _this2.props.onConnect();
                  });
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })();
      });
      function generateCode() {
        return _generateCode.apply(this, arguments);
      }
      return generateCode;
    }()
  }, {
    key: "getState",
    value: function getState() {
      return Object.assign({}, this.state);
    }
  }, {
    key: "onAuthorise",
    value: function () {
      var _onAuthorise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
        var _data, encrypted, publicKey, event, _yield$this$props$wor, OK;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              this.setStateAsync({
                loading: true
              });
              this.cancelTimer();
              data = (0, _helpers.safeJSONParse)(data);
              _data = data, encrypted = _data.encryptedPrivateKey, publicKey = _data.publicKey;
              event = _cryptoWorker.CW_DECRYPT_MASTER_SECRET_KEY;
              _context3.next = 8;
              return this.props.worker({
                encrypted: encrypted,
                event: event,
                publicKey: publicKey
              });
            case 8:
              _yield$this$props$wor = _context3.sent;
              OK = _yield$this$props$wor.OK;
              if (OK) {
                _context3.next = 12;
                break;
              }
              throw new Error('Authentication unsuccessful.');
            case 12:
              if (!this.props.onSignIn) {
                _context3.next = 15;
                break;
              }
              _context3.next = 15;
              return this.props.onSignIn(data);
            case 15:
              this.setStateAsync({
                counter: 0,
                loading: false
              });
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);
              this.onError(_context3.t0);
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 18]]);
      }));
      function onAuthorise(_x) {
        return _onAuthorise.apply(this, arguments);
      }
      return onAuthorise;
    }()
  }, {
    key: "onConnect",
    value: function () {
      var _onConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this3 = this;
        var _this$props, processSocketEvent, worker, sid, mock, _yield$worker, publicKey, socketId, counter;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _this$props = this.props, processSocketEvent = _this$props.processSocketEvent, worker = _this$props.worker;
              _context4.next = 4;
              return processSocketEvent({
                event: _socket.SM_GET_ID
              });
            case 4:
              sid = _context4.sent;
              _context4.next = 7;
              return processSocketEvent({
                event: _socket.SM_IS_MOCK
              });
            case 7:
              mock = _context4.sent;
              _context4.next = 10;
              return worker({
                event: _cryptoWorker.CW_QR_AUTH_SET,
                mock: mock,
                sid: sid
              });
            case 10:
              _yield$worker = _context4.sent;
              publicKey = _yield$worker.publicKey;
              socketId = _yield$worker.socketId;
              if (this.mounted) {
                counter = this.state.counter + 1;
                this.setState({
                  blurred: false,
                  counter: counter,
                  publicKey: publicKey,
                  socketId: socketId
                }, function () {
                  if (_this3.props.onConnect) _this3.props.onConnect();
                  var delay = _this3.props.refreshTimeout || _const.QR_AUTH_REFRESH_TIMEOUT;
                  _this3.timer = setTimeout(function () {
                    if (isCrossOrigin(_this3.target)) return;
                    _this3.socketDisconnect(function () {
                      if (canRefreshCode(counter, _this3.props.refreshLimit)) {
                        _this3.addSocketHooks();
                      } else {
                        _this3.setState({
                          refreshable: true
                        });
                      }
                    });
                  }, delay);
                });
              }
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](0);
              this.onError(_context4.t0);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 16]]);
      }));
      function onConnect() {
        return _onConnect.apply(this, arguments);
      }
      return onConnect;
    }() // TODO: show user-friendly error message here
  }, {
    key: "onError",
    value: function onError(err) {
      var message = _typeof(err) === 'object' ? err.message : err;
      console.log(message);
      this.setStateAsync({
        loading: false
      });
    }
  }, {
    key: "onRefresh",
    value: function onRefresh() {
      var _this4 = this;
      this.setState({
        counter: 0,
        refreshable: false
      }, function () {
        if (isSameOrigin(_this4.target)) {
          _this4.setState({
            refreshable: false
          }, function () {
            return _this4.addSocketHooks();
          });
        } else if (_this4.props.onRefresh) {
          _this4.props.onRefresh();
        } else {
          console.warn('Cannot dispatch a cross-origin event: `onRefresh()` method not defined!');
        }
      });
    }
  }, {
    key: "onSocketMessage",
    value: function onSocketMessage(event, data) {
      switch (event) {
        case _events.QR_AUTH_LOADING:
          return this.setStateAsync({
            loading: data.loading
          });
        case _events.QR_AUTH_REFRESH:
          return data.refreshable ? this.setState({
            refreshable: true
          }) : this.onRefresh();
        case _socket.SM_DISCONNECT:
          return this.setState({
            blurred: true
          });
        case _socket.WS_AUTHORISE:
          return this.props.worker ? this.onAuthorise(data) : null;
        case _socket.WS_CONNECT:
          return this.onConnect(data);
        case _socket.WS_SIGNOUT:
          return this.props.onSignOut ? this.props.onSignOut(data) : null;
        default:
          return null;
      }
    }

    /**
     * Used to set the initial state when we generate a new code and to
     * synchronise states between the web app and the extension.
     *
     * @param {string} publicKey
     * @param {string} socketId
     * @param {boolean} [refreshable=false]
     */
  }, {
    key: "passState",
    value: function passState(publicKey, socketId) {
      var refreshable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var state = {
        blurred: false,
        refreshable: refreshable
      };
      if (publicKey) state.publicKey = publicKey;
      if (socketId) state.socketId = socketId;
      this.setState(state);
    }
  }, {
    key: "setStateAsync",
    value: function setStateAsync() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.mounted) this.setState(state);
    }
  }, {
    key: "socketDisconnect",
    value: function () {
      var _socketDisconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(callback, unmounting) {
        var _this5 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.mounted) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.prev = 2;
              _context5.next = 5;
              return this.props.processSocketEvent({
                event: _socket.SM_DISCONNECT
              });
            case 5:
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](2);
              console.log(_context5.t0);
            case 10:
              if (!unmounting) {
                _context5.next = 12;
                break;
              }
              return _context5.abrupt("return");
            case 12:
              this.setState({
                blurred: true
              }, function () {
                if (_this5.props.onDisconnect) {
                  var refreshable = !canRefreshCode(_this5.state.counter, _this5.props.refreshLimit);
                  _this5.props.onDisconnect(refreshable);
                }
                if (callback) callback();
              });
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 7]]);
      }));
      function socketDisconnect(_x2, _x3) {
        return _socketDisconnect.apply(this, arguments);
      }
      return socketDisconnect;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_QR["default"], {
        blurred: this.state.blurred,
        loading: this.state.loading,
        loadingText: this.props.loadingText,
        onRefresh: this.onRefresh,
        refreshable: this.state.refreshable,
        refreshString: this.props.refreshString,
        value: toValue(this.state.publicKey, this.state.socketId)
      });
    }
  }]);
}(_react["default"].Component);
QRAuth.defaultProps = {
  target: SAME_ORIGIN
};
var _default = exports["default"] = QRAuth;